import {
  TYPES as PROJECTS_STORES_TYPES,
  ProjectStoreInjector,
} from '@desygner/ui-features-projects';

import { appContainer } from '../../../inversify.config';
import { TYPES } from '../../../inversify.types';
import { IViewerStoreInjector } from '../../../store';
import { VideoManager } from '../video-manager';
import { VirtualizerService } from '../virtualizer-service';

export const arrowUpShortcut = {
  key: new Set(['ArrowUp']),
  callBackFunction: () => {
    const { setSelectedPageNumber, selectedPageNumber, pageMode } = appContainer
      .get<IViewerStoreInjector>(TYPES.Store.Viewer)
      .getState();
    const { project } = appContainer
      .get<ProjectStoreInjector>(PROJECTS_STORES_TYPES.ProjectsStore)
      .getState();
    const virtualizer = appContainer.get<VirtualizerService>(TYPES.Viewer.VirtualizerService);
    const totalPages = project?.currentProject?.total_pages ?? 0;
    const currentPage = selectedPageNumber - 1 < 1 ? totalPages : selectedPageNumber - 1;

    if (pageMode === 'single') {
      const videoManager = appContainer.get<VideoManager>(TYPES.Viewer.VideoManager);

      videoManager.pauseCurrentActiveVideo();
    }

    virtualizer.scrollToIndex(currentPage - 1);
    setSelectedPageNumber(currentPage);
  },
};
